import cx from 'classnames';
import React from 'react';

type LineProps = {
    active?: boolean;
};

export const LineSVG: React.FC<LineProps> = React.memo((props) => {
    return (
        <svg
            width="1"
            height="43"
            viewBox="0 0 1 43"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <line
                x1="0.5"
                y1="2.18555e-08"
                x2="0.499998"
                y2="43"
                stroke="#3150CC"
            />
            <line
                className={cx({ draw: props.active })}
                x1="0.5"
                y1="2.18555e-08"
                x2="0.499998"
                y2="43"
                stroke="#A9A8B3"
            />
        </svg>
    );
});
